import { render, staticRenderFns } from "./FormReg.vue?vue&type=template&id=e4116a10&scoped=true"
import script from "./FormReg.vue?vue&type=script&lang=js"
export * from "./FormReg.vue?vue&type=script&lang=js"
import style0 from "./FormReg.vue?vue&type=style&index=0&id=e4116a10&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4116a10",
  null
  
)

export default component.exports